// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"wM12j","contentWrapper":"_2lOnY","offerContainer":"JJPBM","offerLink":"_1ALNl","offerModal":"_1VrkD","noAlignment":"_3XXZC"};